<template>
  <b-overlay :show="mostrarLoader" opacity="0.50" rounded="sm">
    <b-card class="div-with-loading vs-con-loading__container mt-2" v-if="rol">
      <div class="text-center">
        <h4 class="leading-none font-medium" color="primary">
          {{ rol.nombre }}
        </h4>
      </div>

      <b-row>
        <!-- image card -->
        <b-col md="6" lg="6">
          <b-card title="Permisos disponibles" title-color="primary">
            <app-collapse type="border">
              <app-collapse-item
                v-for="(item, key) in permisos"
                :key="item.id"
                title="collapse1"
                is-visible
              >
                <div slot="header">
                  <strong v-if="item">{{
                    Object.values(item)[0].modulo.nombre
                  }}</strong>
                </div>

                <div
                  v-for="(value, key) in item"
                  v-if="!asignados.includes(value.token)"
                >
                  <span v-b-tooltip.hover :title="value.descripcion"
                    ><feather-icon
                      icon="ArrowRightIcon"
                      class="float-right"
                      svg-classes="h-5 w-5 mr-4 hover:text-primary cursor-pointer"
                      @click="agregarPermiso(value.token)"
                    />
                    {{ value.nombre_permiso }}</span
                  >
                </div>
              </app-collapse-item>
            </app-collapse>
          </b-card>
        </b-col>
        <b-col md="6" lg="6">
          <b-card title="Permisos asignados" title-color="primary">
            <app-collapse type="border">
              <app-collapse-item
                v-for="(item, key) in permisos"
                :key="item.id"
                title="collapse2"
                is-visible
              >
                <div slot="header">
                  <strong v-if="item">{{
                    Object.values(item)[0].modulo.nombre
                  }}</strong>
                </div>

                <div
                  v-for="(value, key) in item"
                  v-if="asignados.includes(value.token)"
                >
                  <span v-b-tooltip.hover :title="value.descripcion"
                    ><feather-icon
                      icon="ArrowLeftIcon"
                      class="float-left"
                      svg-classes="h-5 w-5 mr-4 hover:text-primary cursor-pointer"
                      @click="eliminarPermiso(value.token)"
                    />
                    {{ value.nombre_permiso }}
                  </span>
                </div>
              </app-collapse-item>
            </app-collapse>
          </b-card>
        </b-col>
      </b-row>
      <b-button
        id="button-with-loading"
        type="submit"
        variant="primary"
        class="mr-1 btn-guardar"
        :disabled="bloqueo_boton"
        @click="asignarPermisos"
      >
        <feather-icon icon="SaveIcon" size="16" class="align-text-top" />
        <span>&nbsp;Guardar</span>
      </b-button>
    </b-card>
  </b-overlay>
</template>

<script>
import {
  BCard,
  BTooltip,
  BButton,
  VBTooltip,
  BRow,
  BCol,
  BCardText,
  BOverlay,
} from "bootstrap-vue";
import axios from "@/libs/axios";
import BCardCode from "@core/components/b-card-code";
import AppCollapse from "@core/components/app-collapse/AppCollapse.vue";
import AppCollapseItem from "@core/components/app-collapse/AppCollapseItem.vue";
import $ from "jquery";
import ToastificationContent from "@core/components/toastification/ToastificationContent";
import actions from "@/assets/utils/utils";
import Vue from "vue";

export default {
  components: {
    BCardCode,
    BCard,
    BTooltip,
    AppCollapse,
    AppCollapseItem,
    BButton,
    BRow,
    BCol,
    BCardText,
    ToastificationContent,
    BOverlay,
  },
  directives: {
    "b-tooltip": VBTooltip,
  },
  data() {
    return {
      rol: "",
      permisos: {},
      asignados: [],
      bloqueo_boton: false,
      token: "",
      mostrarLoader: false,
    };
  },

  created() {
    this.comprobarPermisos();
    $("#btn-excel").remove();
    $("#btn-pdf").remove();
    $("#btn-print").remove();
    $("#eliminar-viajes").remove();
    $("#btn-abrir-caja").remove();
    this.setToken();
  },

  mounted() {
    // this.cargarRol()
    this.token = this.$route.params.token;
    this.cargarPermisos();
  },

  methods: {
    comprobarPermisos() {
      if (
        localStorage.getItem("permisos").indexOf("usu_rol_asignar_permiso") ===
        -1
      ) {
        this.$router.push({ name: "not-permitted" });
      }
    },

    cargarRol() {
      this.openLoadingInDiv();
      axios
        .get(`api/rol/${this.$route.params.token_publico}`)
        .then((response) => {
          this.rol = response.data;
          this.closeLoadingInDiv();
        });
    },

    cargarPermisos() {
      this.mostrarLoader = true;
      axios
        .post("api", {
          query: `query administrarPermisos($tokenRol: String!){
            administrarPermisos(tokenRol:$tokenRol){
                permisosDisponibles,
                permisosAsignados,
                rol{
                    nombre,
                    descripcion,
                    codigo
                },
                status,
                message
            }
        }`,
          variables: {
            tokenRol: this.token,
          },
        })
        .then((response) => {
          if (response.status === 200) {
            if (response.data.data.administrarPermisos.status === "success") {
              this.permisos = JSON.parse(
                response.data.data.administrarPermisos.permisosDisponibles
              );
              this.asignados =
                response.data.data.administrarPermisos.permisosAsignados;
              this.rol = response.data.data.administrarPermisos.rol;
            } else {
              this.$router.push({ name: "error-404" });
            }
          }
          this.mostrarLoader = false;
        });
    },

    asignarPermisos(e) {
      actions.bloquearBoton();
      axios
        .post("api", {
          query: `query asignarPermisosNuevos($tokenRol: String!, $permisosNuevos: [String]){
            asignarPermisosNuevos(tokenRol:$tokenRol, permisosNuevos:$permisosNuevos){
                status,
                message
            }
        }`,
          variables: {
            tokenRol: this.token,
            permisosNuevos: this.asignados,
          },
        })
        .then((response) => {
          if (response.status === 200) {
            if (response.data.data.asignarPermisosNuevos.status === "success") {
              this.showToast();
            }
          }
          actions.desbloquearBoton();
        });
    },

    agregarPermiso(permiso_token) {
      this.asignados.push(permiso_token);
    },

    eliminarPermiso(permiso_token) {
      this.asignados.splice(this.asignados.indexOf(permiso_token), 1);
    },

    showToast() {
      this.$toast.success(
        {
          component: ToastificationContent,
          props: {
            title: "Permisos",
            icon: "InfoIcon",
            text: "Se ha guardado con éxito los permisos",
          },
        },
        {
          position: "bottom-right",
        }
      );
    },

    setToken() {
      const usuarioCookie = this.$cookie.get("usuario");
      if (usuarioCookie != null) {
        const user = JSON.parse(usuarioCookie);
        axios.defaults.headers.common.Authorization = `JWT ${user.token}`; // for all requests
      }
    },
  },
};
</script>

<style>
.vs-collapse-item.open-item .vs-collapse-item--content {
  max-height: 100% !important;
}
</style>
